import React, { useEffect } from "react";
import { useGetCorporatePlansSummaryQuery } from "../../../../redux/service/modules/dashboard";
import PaginatedDataTable from "../../../../components/table/PaginatedDataTable";
import { useSelector } from "react-redux";

const CAccessSummary = ({ appliedFilters, setRequiredFilters }) => {
    const dateRange = useSelector((state) => state.date);
    useEffect(() => {
        setRequiredFilters(["user"]);
    }, []);

    return (
        <PaginatedDataTable
            queryHook={useGetCorporatePlansSummaryQuery}
            initialDateRange={dateRange}
            firstColumnWidth="100px"
            isColumnSticky={true}
            stickyColumnsCount={2}
            appliedFilters={appliedFilters}
        />
    );
};

export default CAccessSummary;
